import React from "react";
import { TriyoForm } from "../../../../../components/TriyoForm";
import "./template-task-creation.scss";
import taskRecurrenceIcon from "../../../../../assets/icons/Task-Recurrence-16px-Blue-60.svg";
import PropTypes from "prop-types";

const TemplateTaskCreationPanelFormMiddleCheckboxNew = ({
  values,
  setFieldValue,
}) => {
  return (
    <div className="task-accordion-container">
      <div className="heading">
        <div className="heading-description">
          <img className="heading-image" alt="Task Recurrence Individual Tasks" src={taskRecurrenceIcon} />
          <h4 className="heading-name">Generate Individual Tasks</h4>
        </div>
        <TriyoForm.Toggle
          id="IndividualTasks"
          checked={values.IndividualTasks}
          onChange={() => {
            setFieldValue("IndividualTasks", !values.IndividualTasks);
            setFieldValue("IndividualTasksNewMembers", false);
          }}
        />
      </div>
      {values.IndividualTasks && (
        <>
          <h4 className="recurrence-details">
            By default, when a Task is created using the Task Type, it creates a
            Task assigned to all the individuals on the project. When this
            option is selected when the Task Type is used it will create an
            Individual Task for each member of the project.
          </h4>
          <div className="heading">
            <div className="heading-description">
              <img className="heading-image" alt="Task Recurrence Individual Tasks New Members" src={taskRecurrenceIcon} />
              <h4 className="heading-name">
                Generate a Task when a new Project Member is added
              </h4>
            </div>
            <TriyoForm.Toggle
              id="IndividualTasksNewMembers"
              checked={values.IndividualTasksNewMembers}
              onChange={() => {
                setFieldValue(
                  "IndividualTasksNewMembers",
                  !values.IndividualTasksNewMembers
                );
              }}
            />
          </div>
          <h4 className="recurrence-details">
            When a new Member is added to the Project, a Task will be automatically generated using this Task Type.
            This does not apply to new Project Owner(s) added to the Project after Creation.
          </h4>          
        </>
      )}
    </div>
  );
};

TemplateTaskCreationPanelFormMiddleCheckboxNew.propTypes = {
  values: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};
export default TemplateTaskCreationPanelFormMiddleCheckboxNew;
